// ORIGINAL PACKAGE: "react-native-awesome-alerts"

import { useCallback, useEffect, useState } from "react";
import {
  ActivityIndicator,
  Animated,
  BackHandler,
  Modal,
  Platform,
  Text,
  Pressable,
  View,
} from "react-native";

import PropTypes from "prop-types";
import { StyleSheet, Dimensions } from "react-native";

const { height, width } = Dimensions.get("window");

const styles = StyleSheet.create({
  container: {
    flex: 1,
    width: "100%",
    height: "100%",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    zIndex: 1000,
  },
  overlay: {
    width: width,
    height: height,
    position: "absolute",
    backgroundColor: "rgba(52,52,52,0.5)"
  },
  contentContainer: {
    maxWidth: "90%",
    borderRadius: 5,
    backgroundColor: "white",
    // padding: 10
  },
  content: {
    justifyContent: "center",
    alignItems: "center",
    padding: 10
  },
  action: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "flex-end",
    marginTop: 5
  },
  title: {
    paddingVertical: 5,
    paddingHorizontal: 15,
    color: "#626262",
    fontSize: 18,
    textAlign: "center"
  },
  message: {
    paddingTop: 5,
    color: "#7b7b7b",
    fontSize: 14
  },
  button: {
    paddingHorizontal: 10,
    paddingVertical: 7,
    margin: 5,
    borderRadius: 5
  },
  buttonText: {
    color: "#fff",
    fontSize: 13,
    textAlign: "center",
  }
});

const HwBackHandler = (Platform.OS==="web"?window:BackHandler);
// if (Platform.OS!=="web") {
//   HwBackHandler.removeEventListener = HwBackHandler.remove; // alias for mobile OS.
// }
const HW_BACK_EVENT = "hardwareBackPress";

const showSelf = { current: false }

const AwesomeAlert = (props) => {

  props = {...AwesomeAlert.defaultProps, ...props}

  const springValue = new Animated.Value(props.animatedValue);
  const [, _toggleForceRender] = useState(false);
  // const [ showSelf, setShowSelf ] = useState(false);
  // const showSelf = useRef(false);

  useEffect(()=>{
    return ()=>{
      // if (Platform.OS!=="web") {
      //   HwBackHandler.removeEventListener(HW_BACK_EVENT, _handleHwBackEvent);
      // }
    }
  },[]);

  useEffect(()=>{
    if (!!props.show) {
      _springShow();
    } else if (!!showSelf.current) {
      _springHide();
    }
  },[showSelf]);

  const _springShow = useCallback(() => {
    HwBackHandler.addEventListener(HW_BACK_EVENT, _handleHwBackEvent);
    showSelf.current = true;
    _toggleForceRender(s=>(!s));
    const { useNativeDriver = false } = props;
    Animated.spring(springValue, {
      toValue: 1,
      bounciness: 10,
      useNativeDriver,
    }).start();
  },[showSelf]);

  const _springHide = useCallback(() => {
    const { useNativeDriver = false } = props;
    if (showSelf.current === true) {
      showSelf.current = false;
      // if (Platform.OS!=="web") {
      //   HwBackHandler.removeEventListener(HW_BACK_EVENT, _handleHwBackEvent);
      // }
      if (!props.show) {
        _toggleForceRender(s=>(!s));
      } else {
        Animated.spring(springValue, {
          toValue: 0,
          tension: 10,
          useNativeDriver,
        }).start();
        setTimeout(() => {
          _toggleForceRender(s=>(!s));
          _onDismiss();
        }, 100);
      }
    }
  },[showSelf]);

  const _handleHwBackEvent = useCallback(() => {
    const { closeOnHardwareBackPress } = props;
    if (!!showSelf.current && closeOnHardwareBackPress) {
      _springHide();
      return true;
    } else if (!closeOnHardwareBackPress && !!showSelf.current) {
      return true;
    }
    return false;
  },[showSelf]);

  const _onTapOutside = useCallback(() => {
    const { closeOnTouchOutside } = props;
    if (closeOnTouchOutside) _springHide();
  },[showSelf]);

  const _onDismiss = useCallback(() => {
    const { onDismiss } = props;
    onDismiss && onDismiss();
  },[showSelf]);

  const _renderButton = useCallback((data) => {
    const {
      testID,
      text,
      backgroundColor,
      buttonStyle,
      buttonTextStyle,
      onPress,
    } = data;
    return (
      <Pressable testID={testID} onPress={onPress}>
        <View style={{...styles.button, backgroundColor:backgroundColor, ...buttonStyle}}>
          <Text style={{...styles.buttonText, ...buttonTextStyle}}>{text}</Text>
        </View>
      </Pressable>
    );
  },[showSelf]);

  const _renderAlert = useCallback(() => {
    const animation = { transform: [{ scale: springValue }] };

    const { showProgress } = props;
    const { title, message, customView = null } = props;

    const {
      showCancelButton,
      cancelText,
      cancelButtonColor,
      cancelButtonStyle,
      cancelButtonTextStyle,
      onCancelPressed,
      cancelButtonTestID
    } = props;

    const {
      showConfirmButton,
      confirmText,
      confirmButtonColor,
      confirmButtonStyle,
      confirmButtonTextStyle,
      onConfirmPressed,
      confirmButtonTestID
    } = props;

    const {
      alertContainerStyle,
      overlayStyle,
      progressSize,
      progressColor,
      contentContainerStyle,
      contentStyle,
      titleStyle,
      messageStyle,
      actionContainerStyle,
    } = props;

    const cancelButtonData = {
      testID: cancelButtonTestID,
      text: cancelText,
      backgroundColor: cancelButtonColor,
      buttonStyle: cancelButtonStyle,
      buttonTextStyle: cancelButtonTextStyle,
      onPress: onCancelPressed,
    };

    const confirmButtonData = {
      testID: confirmButtonTestID,
      text: confirmText,
      backgroundColor: confirmButtonColor,
      buttonStyle: confirmButtonStyle,
      buttonTextStyle: confirmButtonTextStyle,
      onPress: onConfirmPressed,
    };

    return (
      <View style={{...styles.container, ...alertContainerStyle}}>
        <Pressable onPress={_onTapOutside} style={{...styles.overlay,...overlayStyle}} />
        <Animated.View style={{...styles.contentContainer, ...animation, ...contentContainerStyle}}>
          <View id="singleton_modal" style={{...styles.content, ...contentStyle}}>
            {showProgress ? (
              <ActivityIndicator size={progressSize} color={progressColor} />
            ) : null}
            {title ? (
              <Text style={{...styles.title, ...titleStyle}}>{title}</Text>
            ) : null}
            {message ? (
              <Text style={{textAlign:"center",paddingBottom:10, ...styles.message, ...messageStyle}}>{message}</Text>
            ) : null}
            {customView}
          </View>
          <View style={{...styles.action, ...actionContainerStyle}}>
            {showCancelButton ? _renderButton(cancelButtonData) : null}
            {showConfirmButton ? _renderButton(confirmButtonData) : null}
          </View>
        </Animated.View>
      </View>
    );
  },[showSelf]);

  const { modalProps = {}, closeOnHardwareBackPress } = props;

  const wrapInModal = (Platform.OS === "android" || Platform.OS === "ios");
  return (!!showSelf.current ?
    wrapInModal ? (
      <Modal
        animationType="none"
        transparent={true}
        visible={props.show}
        propagateSwipe={true}
        onRequestClose={() => {
          if (!!showSelf.current && closeOnHardwareBackPress) {
            _springHide();
          }
        }}
        {...modalProps}
      >
        {_renderAlert()}
      </Modal>
    ) : _renderAlert()
  : null);

};

const isOpen = ()=>{return showSelf.current;};

export default AwesomeAlert;
export {
  isOpen
};

AwesomeAlert.propTypes = {
  show: PropTypes.bool,
  animatedValue: PropTypes.number,
  useNativeDriver: PropTypes.bool,
  showProgress: PropTypes.bool,
  title: PropTypes.string,
  message: PropTypes.string,
  closeOnTouchOutside: PropTypes.bool,
  closeOnHardwareBackPress: PropTypes.bool,
  showCancelButton: PropTypes.bool,
  showConfirmButton: PropTypes.bool,
  cancelText: PropTypes.string,
  confirmText: PropTypes.string,
  cancelButtonColor: PropTypes.string,
  confirmButtonColor: PropTypes.string,
  onCancelPressed: PropTypes.func,
  onConfirmPressed: PropTypes.func,
  customView: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.node,
    PropTypes.func,
  ]),
  modalProps: PropTypes.object,
  cancelButtonTestID: PropTypes.string,
  confirmButtonTestID: PropTypes.string
};

AwesomeAlert.defaultProps = {
  show: false,
  animatedValue: 0.3,
  useNativeDriver: false,
  showProgress: false,
  closeOnTouchOutside: true,
  closeOnHardwareBackPress: true,
  showCancelButton: false,
  showConfirmButton: false,
  cancelText: "Cancel",
  confirmText: "Confirm",
  cancelButtonColor: "#D0D0D0",
  confirmButtonColor: "#AEDEF4",
  customView: null,
  modalProps: {},
  cancelButtonTestID: "awesome-alert-cancel-btn",
  confirmButtonTestID: "awesome-alert-confirm-btn"
};
